import type { Difficulty, LevelDefinition } from "@/domain";

export type HabitsActivityType =
  | "pack-schoolbag"
  | "daily-routine"
  | "school-scenarios";

interface HabitsLevelInput<TPayload> {
  activityType: HabitsActivityType;
  difficulty: Difficulty;
  objectives: string[];
  title: string;
  instruction: string;
  promptAudio?: string;
  payload: TPayload;
}

export function createHabitsLevel<TPayload>({
  activityType,
  difficulty,
  objectives,
  title,
  instruction,
  promptAudio,
  payload
}: HabitsLevelInput<TPayload>): LevelDefinition<TPayload> {
  const mediaName = activityType + "-" + difficulty;

  return {
    id: "habits-" + mediaName,
    domain: "habits",
    activityType,
    difficulty,
    objectives,
    title,
    instruction,
    promptAudio: promptAudio ?? "/audio/habits/" + mediaName + ".ogg",
    assets: ["/assets/habits/" + mediaName + ".webp"],
    payload
  };
}
